import React, { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import StandardList from "../../../common/listing/list.component.jsx"
import EcommerceConfigurationService from "../../../state/ecommerce-configuration/EcommerceConfigurationService"
import GlobalHelper from "../../../common/GlobalHelper"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import QuoteFormConfiguration from "../../../state/ecommerce-configuration/EcommerceQuoteFormConfiguration"
import { injectIntl } from "react-intl"
import { Intl } from "../../../state/helpers/IntlProps"
import { ecommerceItemLabelMessages, ecommerceTypeLabelMessages } from "../messages/EcommerceItemMessages"

type OwnProps = {
    intl: Intl
    onFieldSelectCallBack: (field) => void,
    currentFields?: QuoteFormConfiguration[],
    onClose: () => void,
}


const headers = [
    <FormattedMessage
        key="ecommerce.componentes.ecommerce_add_form_fields_modal.field_name_label"
        id="ecommerce.componentes.ecommerce_add_form_fields_modal.field_name_label"
        defaultMessage="Field Name"
    />,
    <FormattedMessage
        key="ecommerce.componentes.ecommerce_add_form_fields_modal.field_type_label"
        id="ecommerce.componentes.ecommerce_add_form_fields_modal.field_type_label"
        defaultMessage="Input Type"
    />,
]

const EcommerceFormFieldsList = (props: OwnProps) => {
    const [fieldsFromBackend, setFieldsFromBackend] = useState<QuoteFormConfiguration[]>([])

    useEffect(() => {
        getFormFields()
    }, [])

    const getFormFields = async () => {
        const acct = AppContext.getAccount().id

        EcommerceConfigurationService.GetQuoteFormConfiguration(
            GlobalHelper.getIntegrationSupportingEcommerceConfiguration(),
            acct
        ).then((res) => {
            const fields: QuoteFormConfiguration[] = res
            if (props.currentFields && props.currentFields.length <= 0) {
                setFieldsFromBackend(fields)
                return
            }
            const fieldsNonDuplicated: QuoteFormConfiguration[] = []
            for (const field of fields) {
                // @ts-ignore todo fix
                const castedField = new QuoteFormConfiguration(field)
                const fieldName = castedField.getAttributes().name
                if (props.currentFields && props.currentFields.filter(e => e.getAttributes().name == fieldName).length <= 0) {
                    if (castedField.getAttributes().subFields?.length > 0) {
                        const castedSubFieldList: QuoteFormConfiguration[] = []
                        const subFieldList = castedField.getAttributes().subFields
                        for (const subfield of subFieldList) {
                            // @ts-ignore todo fix
                            const castedSubField = new QuoteFormConfiguration(subfield)
                            castedSubFieldList.push(castedSubField)
                        }
                        castedField.setAttributes("subFields", castedSubFieldList)
                    }
                    fieldsNonDuplicated.push(castedField)
                }
            }
            setFieldsFromBackend(fieldsNonDuplicated)
        })
    }

    const row = (item) => {
        if (!(item instanceof QuoteFormConfiguration)) {
            item = new QuoteFormConfiguration(item)
        }

        let label = ""
        if (item.getAttributes() && ecommerceItemLabelMessages[item.getAttributes().name]) {
            label = props.intl.formatMessage(ecommerceItemLabelMessages[item.getAttributes().name])
        } else if (item.getAttributes()) {
            label = item.getAttributes().name
        }
        let fieldType = ""
        if (item.getAttributes() && ecommerceTypeLabelMessages[item.getAttributes().type]) {
            fieldType = props.intl.formatMessage(ecommerceTypeLabelMessages[item.getAttributes().type])
        } else if (item.getAttributes()) {
            fieldType = item.getAttributes().type
        }

        const row = [
            label,
            fieldType,
        ]
        return {
            metadata: {
                name: item.getAttributes().name,
                type: item.getAttributes().type,
                required: item.getAttributes().required,
                label: item.getAttributes().label || item.getAttributes().name,
                subFields: item.getAttributes().subFields,
                isCustomField: item.getAttributes().isCustomField,
            },
            data: row
        }
    }

    const onFieldSelect = (data) => {
        const x = new QuoteFormConfiguration({id: "", attributes: data, type: "quote-form-configuration"})
        props.onFieldSelectCallBack(x)
        props.onClose()
    }

    const renderFormFields = () => {
        return <StandardList
            tableClassName={"table-hover"}
            className="row pt-3 py-1 px-3"
            headers={headers}
            smallLine={true}
            rows={fieldsFromBackend.map(item => row(item))}
            onRowClick={data => {
                onFieldSelect(data)
            }}
        />
    }


    return (
        <div>
            {renderFormFields()}
        </div>
    )
}

export default injectIntl(EcommerceFormFieldsList)



// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceFormFieldsList.tsx